import { ASYNC_TYPES } from '@travel-frontend/state-handling-sdk';
import { getCurrentUserId } from '../getCurrentUserId.js';
import { isUserIdSet } from '../redux/selectors.js';
export const FETCH_USER_ID = 'uiState/userId/FETCH_USER_ID';
export function fetchUserId() {
    return {
        types: ASYNC_TYPES(FETCH_USER_ID),
        callAPI: () => Promise.resolve(getCurrentUserId()),
        shouldCallAPI: (state) => !isUserIdSet(state),
    };
}
//# sourceMappingURL=actions.js.map